import { render, staticRenderFns } from "./AppointmentsOverview.vue?vue&type=template&id=2d65e088&"
import script from "./AppointmentsOverview.vue?vue&type=script&lang=js&"
export * from "./AppointmentsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports